<div class="flex flex-col h-screen bg-white overflow-hidden">
    <!-- Header -->
    <header class="flex-none p-6 z-20 bg-white relative">
        <a routerLink="/login" class="inline-block">
            <img src="assets/FINTRAX_LOGO_POS.svg" alt="Fintrax" class="h-10" />
        </a>
    </header>

    <!-- Main Content -->
    <main class="flex-grow flex items-center justify-center p-6 bg-slate-50/50 overflow-y-auto">
        <div class="w-full max-w-md bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center my-auto text-center">
            
            @if (success !== undefined && message !== undefined) {
                <div [class]="success ? 'mb-6 p-4 bg-green-50 text-green-700 rounded-lg w-full' : 'mb-6 p-4 bg-red-50 text-red-700 rounded-lg w-full'">
                    <p class="font-medium text-lg mb-2">{{ message }}</p>
                </div>

                @if (success) {
                    <a i18n="@@emailVerification.goToLogin" class="button button-primary huge w-full justify-center" href="/login">
                        Ga naar login
                    </a>
                } @else {
                    <a i18n="@@emailVerification.backToHome" class="button button-secondary huge w-full justify-center" href="/">
                        Terug naar start
                    </a>
                }
            } @else {
                 <app-loading />
                 <p class="mt-4 text-slate-500" i18n="@@emailVerification.verifying">Bezig met verifiëren...</p>
            }
        </div>
    </main>
</div>
